import * as Yup from 'yup'

export const VerifyIdentitySchema = Yup.object({
  firstName: Yup.string().label('First Name').required(),
  lastName: Yup.string().label('Last Name').required(),
  dob: Yup.number().label('Date of Birth').required(),
})

export type VerifyIdentityValues = Yup.InferType<typeof VerifyIdentitySchema>
